import { Injectable, inject } from '@angular/core';
import { asyncScheduler, BehaviorSubject, observeOn } from 'rxjs';
import { TranslateService } from '@ngx-translate/core'; // Zaimportuj TranslateService
import { WcagActionEnum } from './wcag-action.enum';
import { DateTime } from 'luxon';
import { SeatViewModel } from '../model/view-model/screen/seat/seat.view.model';

@Injectable({
  providedIn: 'root'
})
export class WcagService {
  private translate = inject(TranslateService);
  private liveMessageSubject = new BehaviorSubject<string>('');

  liveMessage$ = this.liveMessageSubject.asObservable().pipe(observeOn(asyncScheduler));

  announce(message: string) {
    this.liveMessageSubject.next('');
    setTimeout(() => this.liveMessageSubject.next(message), 50);
  }

  public announceAction(action: WcagActionEnum, data?: any): void {
    let translationKey: string;

    switch (action) {
      case WcagActionEnum.QUANTITY_CHANGE:
        translationKey = 'WCAG_ANNOUNCER.QUANTITY_CHANGE';
        break;
      case WcagActionEnum.QUANTITY_MIN_REACHED:
        translationKey = 'WCAG_ANNOUNCER.QUANTITY_MIN_REACHED';
        break;
      case WcagActionEnum.QUANTITY_MAX_REACHED:
        translationKey = 'WCAG_ANNOUNCER.QUANTITY_MAX_REACHED';
        break;
      case WcagActionEnum.FORM_SUBMIT_SUCCESS:
        translationKey = 'WCAG_ANNOUNCER.FORM_SUBMIT_SUCCESS';
        break;
      case WcagActionEnum.FORM_SUBMIT_ERROR:
        translationKey = 'WCAG_ANNOUNCER.FORM_SUBMIT_ERROR';
        data = { ...data, error: data?.error || 'try again' };
        break;
      case WcagActionEnum.DATA_LOADING_STARTED:
        translationKey = 'WCAG_ANNOUNCER.DATA_LOADING_STARTED';
        break;
      case WcagActionEnum.DATA_LOADING_COMPLETED:
        translationKey = 'WCAG_ANNOUNCER.DATA_LOADING_COMPLETED';
        break;
      case WcagActionEnum.ITEM_ADDED_TO_CART:
        translationKey = 'WCAG_ANNOUNCER.ITEM_ADDED_TO_CART';
        break;
      case WcagActionEnum.ITEM_REMOVED_FROM_CART:
        translationKey = 'WCAG_ANNOUNCER.ITEM_REMOVED_FROM_CART';
        break;
      case WcagActionEnum.DATE_CHANGE:
        translationKey = 'WCAG_ANNOUNCER.DATE_CHANGE';
        data = { date: (data as DateTime)?.toFormat('cccc, dd MMMM') || undefined };
        break;
      case WcagActionEnum.TIME_CHANGE:
        translationKey = 'WCAG_ANNOUNCER.TIME_CHANGE';
        data = { time: (data as DateTime)?.toFormat('HH:mm') || undefined };
        break;
      case WcagActionEnum.CINEMA_SELECTED:
        translationKey = 'WCAG_ANNOUNCER.CINEMA_SELECTED';
        data = { cinema: data?.name || undefined };
        break;
      case WcagActionEnum.SEAT_SELECTED:
        translationKey = 'WCAG_ANNOUNCER.SEAT_SELECTED';
        break;
      case WcagActionEnum.SEAT_UNSELECTED:
        translationKey = 'WCAG_ANNOUNCER.SEAT_UNSELECTED';
        break;
      case WcagActionEnum.ZOOM_IN:
        translationKey = 'WCAG_ANNOUNCER.ZOOM_IN';
        data = { level: data };
        break;
      case WcagActionEnum.ZOOM_OUT:
        translationKey = 'WCAG_ANNOUNCER.ZOOM_OUT';
        data = { level: data };
        break;
      case WcagActionEnum.CUSTOM_MESSAGE:
        this.announce(data as string);
        return;
      default:
        console.warn(`WcagService: Unsuported action: ${WcagActionEnum[action]}`);
        return;
    }

    this.translate.get(translationKey, data).subscribe((translatedMessage: string) => {
      this.announce(translatedMessage);
    });
  }
}
